/**
* Scrolling Image JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Image component.
*/

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    className: 'scrolling-image',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      const pinnedImageWrapper = document.querySelector( '.scrolling-image__pinned-image-wrapper' );
      const component = document.querySelector( '.scrolling-image' );
      const mobileTextContent = document.querySelector( '.scrolling-image__mobile-text-content' );
      const horizontalWords = component ? component.querySelector( '.scrolling-image__horizontal-words' ) : null;

      if ( !pinnedImageWrapper || !component ) return;

      if ( window.innerWidth < 1024 ) {
        const mobileTextHeight = mobileTextContent ? mobileTextContent.offsetHeight : 0;
        gsap.set( pinnedImageWrapper, {y: mobileTextHeight + 40} );

        gsap.to( pinnedImageWrapper, {
          scrollTrigger: {
            trigger: component,
            start: 'top+=40px top',
            end: 'bottom bottom-40px',
            scrub: 1,
            ease: 'power2.out',
          },
          y: () => {
            if ( !horizontalWords ) return 0;
            const wordsTop = horizontalWords.getBoundingClientRect().top + window.scrollY;
            const compTop = component.getBoundingClientRect().top + window.scrollY;
            const relativeWordsTop = wordsTop - compTop;
            return relativeWordsTop - pinnedImageWrapper.clientHeight;
          },
        } );
      } else {
        gsap.to( pinnedImageWrapper, {
          scrollTrigger: {
            trigger: component,
            start: 'top top',
            end: () => {
              const wordsTop = horizontalWords.getBoundingClientRect().top + window.scrollY;
              const compTop = component.getBoundingClientRect().top + window.scrollY;
              const relativeWordsTop = wordsTop - compTop;
              return `+=${relativeWordsTop - pinnedImageWrapper.clientHeight - 32}`;
            },
            scrub: 1,
            ease: 'power2.out',
          },
          y: () => {
            if ( !horizontalWords ) return 0;
            const wordsTop = horizontalWords.getBoundingClientRect().top + window.scrollY;
            const compTop = component.getBoundingClientRect().top + window.scrollY;
            const relativeWordsTop = wordsTop - compTop;
            return relativeWordsTop - pinnedImageWrapper.clientHeight - 32;
          },
        } );
      }

      $( '.scrolling-image' ).each( function( key, val ) {
        const horizontalWord1 = $( this ).find( '.scrolling-image__horizontal-words .word-1' )[0];
        const horizontalWord2 = $( this ).find( '.scrolling-image__horizontal-words .word-2' )[0];
        const horizontalWord3 = $( this ).find( '.scrolling-image__horizontal-words .word-3' )[0];

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: val,
            start: () => 'center 80%',
            end: () => 'bottom 30%',
            toggleClass: {targets: val, className: 'active'},
            scrub: 0,
          },
        } );

        tl.to( horizontalWord1, {x: '10%', ease: 'linear'}, 0 )
            .to( horizontalWord1, {x: '5%', ease: 'linear'}, 0.5 );

        tl.to( horizontalWord2, {x: '-10%', ease: 'linear'}, 0 )
            .to( horizontalWord2, {x: '5%', ease: 'linear'}, 0.5 );

        tl.to( horizontalWord3, {x: '20%', ease: 'linear'}, 0 )
            .to( horizontalWord3, {x: '10%', ease: 'linear'}, 0.5 );
      } );

      ScrollTrigger.refresh();
    },
    finalize: function() {},
  };

  app.registerComponent( 'scrolling-image', COMPONENT );
} )( app );
